<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success" [disabled]="form.pristine || !form.dirty" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    
    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Permiso de Acción</h4>

        <div class="row">
            <div class="col-md-12">                

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            
                            <div class="card-body">
                                <div class="group-filtros">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="">Módulo</label>
                                            <ng-select [items]="listModulos"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdModulo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listModulos || listModulos.length === 0"
                                                       [loading]="!listModulos || listModulos.length === 0"
                                                       notFoundText="Módulo no encontrado"
                                                       placeholder="-- Seleccione un Módulo --"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectModulo()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Acción</label>
                                            <ng-select [items]="listAcciones"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdAccion"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listAcciones || listAcciones.length === 0"
                                                       [loading]="(!listAcciones || listAcciones.length === 0) && (form.value.IdAccion > 0)"
                                                       notFoundText="Acción no encontrada"
                                                       placeholder="-- Seleccione una Acción --"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectAccion()"
                                                       [ngClass]="displayFieldCssNgSelect('IdAccion')">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAccion','required')">
                                                Acción es obligatoria
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAccion','registry_duplicated')">
                                                El permiso de Acción ya existe
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Perfil</label>
                                            <ng-select [items]="listPerfil"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPerfil"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPerfil || listPerfil.length === 0"
                                                       [loading]="!listPerfil || listPerfil.length === 0"
                                                       notFoundText="Perfil no encontrado"
                                                       placeholder="-- Seleccione un Perfil --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPerfil')">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPerfil','required')">
                                                Perfil es obligatorio
                                            </div>
                                        </div>                                        

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Estado</label>
                                            <ng-select [items]="listEstado"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdEstado"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listEstado || listEstado.length === 0"
                                                       [loading]="!listEstado || listEstado.length === 0"
                                                       notFoundText="Estado no encontrado"
                                                       placeholder="-- Seleccione un Estado --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Tipo</label>
                                            <ng-select [items]="listTipo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listTipo || listTipo.length === 0"
                                                       [loading]="!listTipo || listTipo.length === 0"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Tipo --"
                                                       (change)="onSelectTipo()"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Subtipo</label>
                                            <ng-select [items]="listSubTipo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdSubtipo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listSubTipo || listSubTipo.length === 0"
                                                       [loading]="!listSubTipo || listSubTipo.length === 0"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Subtipo --"
                                                       (change)="onSelectSubtipo()"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Edicion</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="Edicion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
